export default "__VITE_ASSET__DBJMt_Uc__"